(function () {
function $031feada4a3b44c2$export$2c579a9f1ddaf08d() {
    const dataToolTips = document.querySelectorAll("[data-tooltip-top], [data-tooltip-right], [data-tooltip-bottom], [data-tooltip-left]");
    dataToolTips.forEach((dataTooltip)=>{
        if (dataTooltip.firstChild.className === "tooltip") return;
        const tooltipText = `<span class="tooltip">${dataTooltip.dataset.tooltipTop ? dataTooltip.dataset.tooltipTop : dataTooltip.dataset.tooltipRight ? dataTooltip.dataset.tooltipRight : dataTooltip.dataset.tooltipBottom ? dataTooltip.dataset.tooltipBottom : dataTooltip.dataset.tooltipLeft}</span>`;
        dataTooltip.insertAdjacentHTML("afterbegin", tooltipText);
    });
    const toolTipsClick = document.querySelectorAll("[data-tooltip-copy]");
    toolTipsClick.forEach((toolTipClick)=>{
        toolTipClick.addEventListener("click", function() {
            const tooltip = toolTipClick.querySelector(".tooltip");
            tooltip.textContent = toolTipClick.dataset.tooltipCopy;
            setTimeout(()=>{
                tooltip.textContent = toolTipClick.dataset.tooltipTop ? toolTipClick.dataset.tooltipTop : toolTipClick.dataset.tooltipRight ? toolTipClick.dataset.tooltipRight : toolTipClick.dataset.tooltipBottom ? toolTipClick.dataset.tooltipBottom : toolTipClick.dataset.tooltipLeft;
            }, 1000);
        });
    });
}
document.addEventListener("DOMContentLoaded", $031feada4a3b44c2$export$2c579a9f1ddaf08d);


document.addEventListener("click", (e)=>{
    // Add class ac-body and hidden to dropdowns
    const accordionBodies = document.querySelectorAll(".ac-body");
    accordionBodies.forEach(function(accordionBody) {
        const accordionHeader = accordionBody.previousElementSibling;
        if (e.target !== accordionBody && e.target !== accordionHeader && !accordionBody.contains(e.target)) {
            accordionHeader.classList.toggle("active");
            accordionBody.classList.toggle("!block");
        }
    });
    // Add class ac-header to the button that opens the dropdown
    if (e.target.classList.contains("ac-header")) {
        const accordionBody = e.target.nextElementSibling;
        const accordionHeader = e.target;
        accordionHeader.classList.toggle("active");
        accordionBody.classList.toggle("!block");
    }
    if (e.target.classList.contains("ac-footer")) {
        const accordionBody = e.target.previousElementSibling;
        const accordionHeader = e.target;
        accordionHeader.classList.toggle("active");
        accordionBody.classList.toggle("!block");
    }
    if (e.target.classList.contains("ac-open-top")) {
        const accordionBody = e.target.nextElementSibling;
        const accordionHeader = e.target;
        accordionHeader.classList.toggle("active");
        if (!accordionBody.classList.contains("!flex")) accordionBody.classList.add("!flex", "gap-3", "bottom-full", "p-1", "bg-white/90", "rounded", "-ml-2");
        else accordionBody.classList.remove("!flex", "gap-3", "bottom-full", "p-1", "bg-white/90", "rounded", "-ml-2");
    }
    if (e.target.classList.contains("overlay")) {
        const overlay = e.target;
        overlay.classList.remove("visible");
    }
});


document.addEventListener("click", (e)=>{
    if (e.target.classList.contains("tab")) {
        const tab = e.target;
        const tabs = document.querySelectorAll(".tab");
        const tabContents = document.querySelectorAll(".tab-content");
        tabs.forEach((tab)=>{
            tab.classList.remove("active");
        });
        tab.classList.add("active");
        tabContents.forEach((tabContent)=>{
            tabContent.classList.remove("active");
            if (tabContent.dataset.tab === tab.dataset.tab) tabContent.classList.add("active");
        });
    }
});


document.addEventListener("click", (e)=>{
    if (e.target.matches("a")) {
        let href = e.target.getAttribute("href");
        if (!href.startsWith("#") || href.startsWith("#") && href.length < 2) return;
        e.preventDefault();
        let target = document.querySelector(href);
        if (!target) return;
        let headerOffset = 130;
        let elementPosition = target.offsetTop;
        let offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }
});


// export const loadMoreBtn = document.querySelector('.load-more')
const $9aa4113698f7fa9e$var$postCount = document.querySelector(".post-listing .post-count");
const $9aa4113698f7fa9e$var$filters = document.querySelectorAll(".filter");
const $9aa4113698f7fa9e$var$searchInput = document.querySelector(".main-search-input");
let $9aa4113698f7fa9e$var$paged = 1;
const $9aa4113698f7fa9e$export$b10b9b608ed3fa77 = async (e, target)=>{
    let cleanResult = false, loadMoreBtn, postContainer, excludePosts;
    const data = new FormData();
    if (e.target.classList.contains("load-more")) {
        excludePosts = [
            ...document.querySelectorAll("[data-post-id]")
        ].map((exP)=>exP.dataset.postId);
        loadMoreBtn = e.target;
        const articleListing = loadMoreBtn.closest(".container");
        postContainer = articleListing.querySelector(".post-listing");
        if (loadMoreBtn.dataset.catId) data.append("cat_id", loadMoreBtn.dataset.catId);
        if (loadMoreBtn.dataset.searchQuery) data.append("search_query", loadMoreBtn.dataset.searchQuery);
    } else loadMoreBtn = document.querySelector(".load-more");
    if (target === "filter") {
        $9aa4113698f7fa9e$var$paged = 1;
        cleanResult = true;
        $9aa4113698f7fa9e$var$searchInput.value = "";
    } else if (target === "loadmore") {
        loadMoreBtn.classList.add("loading");
        cleanResult = false;
        if (excludePosts.length > 0) data.append("exclude", excludePosts);
        data.append("post_type", loadMoreBtn.dataset.postType);
        data.append("card_bg_color", "bg-white");
        data.append("card_text_color", "text-black");
        $9aa4113698f7fa9e$var$paged++;
    } else if (target === "reset") {
        $9aa4113698f7fa9e$var$paged = 1;
        cleanResult = true;
        $9aa4113698f7fa9e$var$searchInput.value = "";
        $9aa4113698f7fa9e$var$filters.forEach((filter)=>filter.checked = false);
    }
    data.append("action", "load_more");
    data.append("security", liGlobal.loadMore);
    data.append("paged", $9aa4113698f7fa9e$var$paged || 1);
    if ($9aa4113698f7fa9e$var$filters) {
        const filterArray = [];
        $9aa4113698f7fa9e$var$filters.forEach((filter)=>{
            if (filter.checked) filterArray.push(filter.dataset.tagId);
        });
        data.append("filter", filterArray);
    }
    fetch(liGlobal.ajaxUrl, {
        method: "POST",
        body: data
    }).then((response)=>response.text()).then((response)=>{
        response = JSON.parse(response);
        if (!response.success) return;
        if (response.data.load_more_btn_text === "Inga fler inl\xe4gg") {
            loadMoreBtn.setAttribute("disabled", "disabled");
            loadMoreBtn.classList.remove("loading");
        } else loadMoreBtn.removeAttribute("disabled");
        loadMoreBtn.textContent = response.data.load_more_btn_text;
        loadMoreBtn.classList.remove("loading");
        const posts = response.data.posts;
        if (!cleanResult) posts.forEach((post)=>{
            postContainer.insertAdjacentHTML("beforeend", post);
        });
        else {
            postContainer.innerHTML = "";
            posts.forEach((post)=>{
                postContainer.insertAdjacentHTML("beforeend", post);
            });
        }
    // postCount.textContent = response.data.found_posts
    }).catch((error)=>{
        console.error("error " + error);
    });
    loadMoreBtn.classList.remove("d-none");
};
document.addEventListener("click", function(e) {
    if (e.target.classList.contains("load-more")) {
        e.preventDefault();
        const loadMore = "loadmore";
        $9aa4113698f7fa9e$export$b10b9b608ed3fa77(e, loadMore);
    }
    if (e.target.classList.contains("filter")) {
        const filter = "filter";
        $9aa4113698f7fa9e$export$b10b9b608ed3fa77(e, filter);
    }
    if (e.target.classList.contains("btn-reset")) {
        const reset = "reset";
        $9aa4113698f7fa9e$export$b10b9b608ed3fa77(e, reset);
    }
});


document.addEventListener("DOMContentLoaded", function() {
    // Add taxonomy name and link on load
    const menuTaxItems = document.querySelectorAll(".menu-item-has-children");
    menuTaxItems.forEach((menuTaxItem)=>{
        const taxName = menuTaxItem.querySelector(".menu-item-title").textContent;
        const taxLink = menuTaxItem.querySelector("a").href;
        const catTitles = menuTaxItem.querySelectorAll(`.sub-cat-title`);
        const catLinks = menuTaxItem.querySelectorAll(`.sub-cat-link`);
        catTitles.forEach((catTitle)=>{
            catTitle.innerHTML = taxName;
        });
        catLinks.forEach((catLink)=>{
            catLink.href = taxLink;
        });
    });
});
const $dd269c43bb3cf205$var$masthead = document.querySelector("#masthead");
function $dd269c43bb3cf205$var$checkScrollPosition() {
    if (window.scrollY > 20) $dd269c43bb3cf205$var$masthead.classList.add("drop-shadow-md", "transition-all", "duration-300");
    else $dd269c43bb3cf205$var$masthead.classList.remove("drop-shadow-md");
}
document.addEventListener("DOMContentLoaded", $dd269c43bb3cf205$var$checkScrollPosition);
window.addEventListener("scroll", $dd269c43bb3cf205$var$checkScrollPosition);


const $d9bbb5e2b12cf194$var$mainMenu = document.querySelector("#main-menu");
const $d9bbb5e2b12cf194$var$menuToggleIcon = document.querySelector("#menu-toggle-icon");
function $d9bbb5e2b12cf194$var$toggleMenu() {
    $d9bbb5e2b12cf194$var$mainMenu.classList.toggle("!flex");
    document.body.classList.toggle("mobile-menu-open");
    $d9bbb5e2b12cf194$var$menuToggleIcon.textContent === "menu" ? $d9bbb5e2b12cf194$var$menuToggleIcon.textContent = "close" : $d9bbb5e2b12cf194$var$menuToggleIcon.textContent = "menu";
}
let $d9bbb5e2b12cf194$var$dropdownBtn, $d9bbb5e2b12cf194$var$dropdown;
const $d9bbb5e2b12cf194$var$submenu_classes = [
    "!block",
    "!opacity-100",
    "!pointer-events-auto",
    "!absolute",
    "!z-10",
    "!top-0",
    "!left-0",
    "!w-full",
    "!h-full"
];
document.addEventListener("click", function(e) {
    if (e.target.closest(".main-menu-toggle-btn")) $d9bbb5e2b12cf194$var$toggleMenu();
    // if clicking outside of dropdown menu and dropdown menu is open then close it
    if ($d9bbb5e2b12cf194$var$dropdown && e.target !== $d9bbb5e2b12cf194$var$dropdown && !$d9bbb5e2b12cf194$var$dropdown.contains(e.target)) {
        $d9bbb5e2b12cf194$var$dropdownBtn.classList.remove("pointer-events-none");
        $d9bbb5e2b12cf194$var$dropdown.classList.remove("!block");
    }
    if (e.target.classList.contains("dropdown-btn")) {
        $d9bbb5e2b12cf194$var$dropdownBtn = e.target;
        $d9bbb5e2b12cf194$var$mainMenu.classList.remove("!flex");
        $d9bbb5e2b12cf194$var$menuToggleIcon.name = "menu";
        $d9bbb5e2b12cf194$var$dropdown = e.target.closest(".dropdown-btn").nextElementSibling;
        if ($d9bbb5e2b12cf194$var$dropdown.classList.contains("!block")) $d9bbb5e2b12cf194$var$dropdown.classList.remove("!block");
        else {
            $d9bbb5e2b12cf194$var$dropdownBtn.classList.add("pointer-events-none");
            $d9bbb5e2b12cf194$var$dropdown.classList.add("!block");
        }
    }
    if (e.target.classList.contains("sub-menu-toggle-button")) {
        if (window.innerWidth > 1024) return;
        const parent = e.target.closest(".menu-item-has-children");
        const submenu = parent.querySelector(".sub-menu");
        if (submenu.classList.contains("!block")) submenu.classList.remove(...$d9bbb5e2b12cf194$var$submenu_classes);
        else submenu.classList.add(...$d9bbb5e2b12cf194$var$submenu_classes);
    }
});


const $772c7635189b3569$var$postCount = document.querySelector(".pc-post-listing .post-count");
const $772c7635189b3569$var$filters = document.querySelectorAll(".filter");
const $772c7635189b3569$var$searchInput = document.querySelector(".search-input");
let $772c7635189b3569$var$paged = 1;
const $772c7635189b3569$export$b10b9b608ed3fa77 = async (e, target)=>{
    let cleanResult = false, loadMoreBtn, postContainer, excludePosts;
    const data = new FormData();
    if (e.target.classList.contains("pc-load-more")) {
        excludePosts = [
            ...document.querySelectorAll("[data-post-id]")
        ].map((exP)=>exP.dataset.postId);
        loadMoreBtn = e.target;
        const postListing = loadMoreBtn.closest(".pc-post-listing");
        data.append("card_bg_color", postListing.dataset.cardBg);
        data.append("card_text_color", postListing.dataset.cardText);
        if (loadMoreBtn.dataset.masonry != "") data.append("masonry", true);
        postContainer = postListing.querySelector(".post-container");
    } else loadMoreBtn = document.querySelector(".pc-load-more");
    if (target === "filter") {
        $772c7635189b3569$var$paged = 1;
        cleanResult = true;
        $772c7635189b3569$var$searchInput.value = "";
    } else if (target === "loadmore") {
        loadMoreBtn.classList.add("loading");
        cleanResult = false;
        if (excludePosts.length > 0) data.append("exclude", excludePosts);
        data.append("post_type", loadMoreBtn.dataset.postType);
        $772c7635189b3569$var$paged++;
    } else if (target === "reset") {
        $772c7635189b3569$var$paged = 1;
        cleanResult = true;
        $772c7635189b3569$var$searchInput.value = "";
        $772c7635189b3569$var$filters.forEach((filter)=>filter.checked = false);
    }
    data.append("action", "load_more");
    data.append("security", liGlobal.loadMore);
    data.append("paged", $772c7635189b3569$var$paged || 1);
    if ($772c7635189b3569$var$filters) {
        const filterArray = [];
        $772c7635189b3569$var$filters.forEach((filter)=>{
            if (filter.checked) filterArray.push(filter.dataset.tagId);
        });
        data.append("filter", filterArray);
    }
    fetch(liGlobal.ajaxUrl, {
        method: "POST",
        body: data
    }).then((response)=>response.text()).then((response)=>{
        response = JSON.parse(response);
        if (!response.success) return;
        if (response.data.load_more_btn_text === "Inga fler inl\xe4gg") {
            loadMoreBtn.setAttribute("disabled", "disabled");
            loadMoreBtn.classList.remove("loading");
        } else loadMoreBtn.removeAttribute("disabled");
        loadMoreBtn.textContent = response.data.load_more_btn_text;
        loadMoreBtn.classList.remove("loading");
        const posts = response.data.posts;
        if (!cleanResult) posts.forEach((post)=>{
            postContainer.insertAdjacentHTML("beforeend", post);
        });
        else {
            postContainer.innerHTML = "";
            posts.forEach((post)=>{
                postContainer.insertAdjacentHTML("beforeend", post);
            });
        }
    // postCount.textContent = response.data.found_posts
    }).catch((error)=>{
        console.error("error " + error);
    });
    loadMoreBtn.classList.remove("hidden");
};
document.addEventListener("click", function(e) {
    if (e.target.classList.contains("pc-load-more")) {
        e.preventDefault();
        const loadMore = "loadmore";
        $772c7635189b3569$export$b10b9b608ed3fa77(e, loadMore);
    }
    if (e.target.classList.contains("pc-filter")) {
        const filter = "filter";
        $772c7635189b3569$export$b10b9b608ed3fa77(e, filter);
    }
    if (e.target.classList.contains("pc-btn-reset")) {
        const reset = "reset";
        $772c7635189b3569$export$b10b9b608ed3fa77(e, reset);
    }
});


const $c001ddf96774b03f$export$becb836e43488847 = ()=>{
    // Target all input containers from all Gravity Forms
    const inputContainers = document.getElementsByClassName("ginput_container");
    if (inputContainers.length) // Setup focus and blur events for each field
    for (const inputContainer of inputContainers){
        // Target input element in container, whether it's an input or a textarea
        const inputElement = inputContainer.querySelectorAll(":scope > *")[0];
        // Label element is always the previous sibling of the input container
        const labelElement = inputContainer.previousElementSibling;
        // Activate label if input has value - this moves the label above the input
        inputElement.addEventListener("focus", (event)=>{
            labelElement.classList.add("active");
        });
        // Deactivate label if input is empty on blur - this moves the label back to its original position
        inputElement.addEventListener("blur", (event)=>{
            if (inputElement.value === "") labelElement.classList.remove("active");
        });
        // If the input has a value on page load (when user submit fails) then activate the label
        // Also prevent animation to avoid flicker
        if (inputElement.value !== "") {
            labelElement.classList.add("no-animation");
            labelElement.classList.add("active");
            setTimeout(()=>{
                labelElement.classList.remove("no-animation");
            }, 200);
        }
    }
};
document.addEventListener("DOMContentLoaded", function() {
    // Have to use jQuery here because the gform_post_render event is triggered by Gravity Forms
    // This fires on page load and on submit.
    jQuery(document).on("gform_post_render", function(event, form_id, current_page) {
        // Move validation error message to bottom of form
        jQuery("div.gform_validation_errors").appendTo("div.gform_body");
        $c001ddf96774b03f$export$becb836e43488847();
    });
}, false);



if (null) null.accept();

})();
//# sourceMappingURL=app.js.map
